
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CTA() {
  return (
    <section className="py-20 relative overflow-hidden" style={{ backgroundColor: '#0092d8' }}>
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          建物のことで困ったら、お気軽にご相談ください
        </h2>
        <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
          リノベーション、メンテナンス、コンサルティングまで、
          建物に関するあらゆる課題に最適なソリューションをご提案いたします。
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-white text-xl"></i>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">お電話でのご相談</h3>
            <p className="text-blue-100 text-sm mb-3">平日 9:00-18:00</p>
            <p className="text-white font-semibold">080-1154-9876（緊急）（緊急）</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-mail-line text-white text-xl"></i>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">メールでのご相談</h3>
            <p className="text-blue-100 text-sm mb-3">24時間受付</p>
            <p className="text-white font-semibold">masuno@mkf23.com</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-map-pin-line text-white text-xl"></i>
              </div>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">お打ち合わせ</h3>
            <p className="text-blue-100 text-sm mb-3">要予約</p>
            <p className="text-white font-semibold">訪問いたします</p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/contact">
            <Button size="lg" className="bg-green-600 text-white hover:bg-green-700 border-2 border-green-600 shadow-lg">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-send-plane-line"></i>
              </div>
              お問い合わせフォーム
            </Button>
          </Link>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white border-2 border-white hover:bg-white hover:text-blue-800 transition-all duration-200 cursor-pointer whitespace-nowrap rounded-lg shadow-lg"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-customer-service-line"></i>
            </div>
            AIアシスタントに相談
          </button>
        </div>
      </div>
    </section>
  );
}
